<template>
    <b-col sm="12" class="mt-2">
        <div class="card">
            <div class="card-header main-card">
                Configuración del envío de planificación
            </div>
            <div class="card-body">
                <b-container class="text-left" >
                    <p class="title">Configuración del envío de la planificación de buses</p>
                    <Spinner v-if="isDataLoading" color="#fedd00" />
                    <div  v-else>
                        <table class="table table-hover table-bordered table-sm mt-1">
                            <thead>
                                <tr>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Número</th>
                                    <th scope="col">Ocupación <br> (excursión)</th>
                                    <th scope="col">Ocupación <br> (recogida)</th>
                                    <th scope="col">Enviar</th>
                                    <th scope="col" style="width: 30%;">Enviar a</th>
                                    <th scope="col" >Enviado</th>
                                    <th scope="col" style="width: 20%" class="text-right">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in planningCommunicationsData" :key="item.id">
                                    <td>
                                        <bus-name-badge :bus="item.bus" />
                                    </td>
                                    <td>
                                        {{item.bus.number}}
                                    </td>
                                    <td>
                                        <bus-occupancy-badge :maxSize="item.bus.max_size" :adults="item.count_customers_excursion" :children="0" />
                                    </td>
                                    <td>
                                        <bus-occupancy-badge :maxSize="item.bus.max_size" :adults="item.count_customers_pickup" :children="0" />
                                    </td>
                                    <td>
                                        <b-form-checkbox
                                            size="lg" v-model="send[idx].checked"
                                            checked="true" @change="toggleSelection(item.bus.id)" class="text-primary" />
                                    </td>
                                    <td>
                                        <input type="text" name="recipient" list="recipients" v-model="send[idx].recipient"  class="p-2 w-100">
                                        <datalist id="recipients">
                                            <option :value="defaultRecipient"/>
                                            <option v-for="recipient in availableRecipients" :key="recipient" :value="recipient"></option>
                                        </datalist>
                                        
                                    </td>
                                    <td class="text-center">
                                        <i v-if="item.sent_planning_events.length > 0" class="fa fa-2x fa-check-circle text-success"></i>
                                        <i v-else class="fa fa-2x fa-times-circle text-warning"></i>
                                        
                                        <bus-planning-send-history-modal :bus="item.bus" :events="item.sent_planning_events" />
                                    </td>
                                    <td class="text-right">
                                        <b-button 
                                            size="sm" variant="light" class="border bg-white mx-1"
                                            @click="sendSimple(item.bus.id)">
                                                <i class="fa fa-envelope fa-fw"></i>
                                                <span>
                                                    Enviar simple
                                                </span>
                                        </b-button>
                                        <b-button
                                            size="sm" variant="light" class="border bg-white mx-1"
                                            v-b-modal="'planningBusHistoryModal_' + item.bus.id"
                                        >
                                            <i class="fa fa-clock-o mr-2 fa-fw"/> Historial
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="my-4 text-right">
                           
                            <b-button 
                                size="lg" variant="light" class="border bg-white mx-2"
                                @click="checkAll(true)">
                                    <i class="fa fa-check fa-fw"></i>
                                    <span>
                                        Marcar todos
                                    </span>
                            </b-button>
                            <b-button 
                                size="lg" variant="light" class="border bg-white mx-2"
                                @click="checkAll(false)">
                                    <i class="fa fa-times fa-fw"></i>
                                    <span>
                                        Desmarcar todos
                                    </span>
                            </b-button>
                            <b-button 
                                size="lg" variant="light" class="border bg-white"
                                :disabled="!activateSendAll"
                                @click="sendChecked()">
                                    <i class="fa fa-envelope fa-fw"></i>
                                    <span>
                                        Enviar marcados
                                    </span>
                            </b-button>
                        </div>
                        <div v-if="showAlertSend">
                            <div class="alert alert-primary text-center">
                                <p>
                                    <i class="fa fa-clock-o fa-2x fa-fw"></i>
                                    <span class="font-weight-bold">
                                        La planificación se está procesando. El envío de los e-mails con la planificación puede tardar unos minutos en completarse si el número de buses y su ocupación es elevada. Puede refrescar el estado del envío pulsando el botón de refrescar.
                                    </span>
                                </p>
                                <b-button 
                                    size="lg" variant="light" class="border bg-white mx-2"
                                    @click="refresh()">
                                        <i class="fa fa-refresh fa-fw"></i>
                                        <span>
                                            Refrescar listado
                                        </span>
                                </b-button>
                            </div>

                        </div>
                    </div>
                 </b-container>
            </div>
        </div>
        {{excursionBuses}} -- {{pickupBuses}} 
        <div>
            {{activeTab}}
        </div>
        <div>
            {{send}}
        </div>
    </b-col>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import BusOccupancyBadge from '../../Excursions/Bus/BusUtils/BusOccupancyBadge'
import BusNameBadge from '../../Excursions/Bus/BusUtils/BusNameBadge'
import BusPlanningSendHistoryModal from './BusPlanningSendHistoryModal'
import Spinner from "vue-spinner/src/ScaleLoader.vue";


export default {
    components: {
        BusOccupancyBadge,
        BusNameBadge,
        BusPlanningSendHistoryModal,
        Spinner,
    },
    data() {
        const defaultRecipient = 'andreupere@gedocu.com'
        
        return {
            showAlertSend: false,
            availableRecipients: [''],
            defaultRecipient: defaultRecipient,
            send: []
        }
    },
    mounted() {
        this.$store
                .dispatch("buses/sentPlanningData") 
        console.log(this.excursionBuses)
        for ( let idx in this.excursionBuses ) {
            this.send.push({
                id: this.excursionBuses[idx].id,
                checked: true,
                recipient: this.defaultRecipient,
                valid: true
            })
        }
        
    },
    computed: {
        ...mapGetters(['activeTab', 'activeOption']),
        ...mapGetters(['excursionBuses', 'pickupBuses', 'planningCommunicationsData']),
        ...mapGetters(['isDataLoading']),
        activateSendAll() {
            for ( let idx in this.send ) {
                if ( this.send[idx].checked ) {
                    return true
                }
            }
            return false
        }
    },
    methods: {
        sendSimple(busId) {
            const checked = this.send.filter(item => item.id == busId)
            this.activateShowAlertSend()
            this.$store.dispatch("buses/sendPlanning", checked)
        },
        toggleSelection(busId) {
        },
        sendChecked() {
            const checked = this.send.filter(item => item.checked == true)
            this.activateShowAlertSend()
            this.$store.dispatch("buses/sendPlanning", checked)
        },
        checkAll(value) {
            for ( let idx in this.send ) {
                this.send[idx].checked = value
            }
        },
        activateShowAlertSend() {
            this.showAlertSend = true
            // setTimeout(() => {
            //     this.showAlertSend = false
            // }, 14000)
        },
        refresh() {
            this.$store
                .dispatch("buses/sentPlanningData") 
        }
    }
}
</script>

<style scoped>
.title {
    font-size: 1.5rem;
    text-align: center;
    margin-top: 10px;
    padding-bottom: 10px;
}
</style>